<template>
  <div>
    <div
      class="menu"
      v-show="show"
      :style="[{ top: top + 'px' }, { right: right + 'px' }]" >
      <div class="item" v-if="search" @click="onClickSearch">
        <i class="icon-search"></i>
        <span class="item-text">搜索</span>
      </div>
      <div class="item" v-if="home">
        <i class="icon-home"></i>
        <span class="item-text">首页</span>
      </div>
      <div class="item" v-if="reload">
        <i class="icon-reload"></i>
        <span class="item-text">刷新</span>
      </div>
      <div class="item" v-if="center">
        <i class="icon-center"></i>
        <span class="item-text">我的拼团</span>
      </div>
    </div>
    <div class="mask" v-show="show" @click="onClose"></div>
  </div>
</template>

<script>
import utils from "../../../../static/js/b_utils.js";
export default {
  name: "moreMenu",
  props: {
    top: Number,
    right: Number,
    search: Boolean,
    home: Boolean,
    reload: Boolean,
    center: Boolean,
    show: Boolean
  },
  data() {
    return {};
  },
  components: {},
  mounted() {
    window.addEventListener("scroll", utils.throttle(this.onClose, 500, 1000));
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    onClickSearch() {
      this.onClose();
      this.$emit("search");
    }
  }
};
</script>

<style scoped lang="scss">
.menu {
  position: fixed;
  padding: 0.46rem;
  background: #fff;
  border: 1px solid rgba(237, 237, 237, 1);
  box-shadow: 0 0.06rem 0.2rem 0 rgba(0, 0, 0, 0.12);
  border-radius: 0.12rem;
  z-index: 100;
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    .item-text {
      color: #222222;
      font-size: 0.28rem;
      margin-left: 0.22rem;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
}
i {
  display: block;
}
.icon-search {
  width: 0.32rem;
  height: 0.32rem;
  background: url("../../../../static/images/fightGroups/icon_search.png")
    no-repeat center center / 100% 100%;
}
.icon-home {
  width: 0.34rem;
  height: 0.3rem;
  background: url("../../../../static/images/fightGroups/icon_home.png")
    no-repeat center center / 100% 100%;
}
.icon-reload {
  width: 0.31rem;
  height: 0.31rem;
  background: url("../../../../static/images/fightGroups/icon_reload.png")
    no-repeat center center / 100% 100%;
}
.icon-center {
  width: 0.3rem;
  height: 0.34rem;
  background: url("../../../../static/images/fightGroups/icon_center.png")
    no-repeat center center / 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/FightGroups/components/Menu.vue